import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

/** Meniul „+ Nou", in tiparul TravelJoy. Contine DOAR lucruri pe care aplicatia chiar
 *  le poate crea — fiecare intrare duce la un formular care scrie in baza. */
const ITEME = [
  { la: '/nou/oferta', titlu: 'Oferta', sub: 'propunere pentru un client' },
  { la: '/nou/rezervare-wizard', titlu: 'Rezervare', sub: 'wizard in 6 pasi' },
  { la: '/nou/rezervare', titlu: 'Rezervare scurta', sub: 'doar datele de baza' },
  { la: '/nou/factura', titlu: 'Factura', sub: 'vanzare sau cumparare' },
  { la: '/bani/incasari', titlu: 'Incasare', sub: 'bani primiti pe o factura' },
  { la: '/bani/plati', titlu: 'Plata', sub: 'bani platiti unui furnizor' },
  { la: '/nou/client', titlu: 'Client', sub: 'persoana sau firma' },
  { la: '/nou/grup', titlu: 'Grup', sub: 'plecare comuna + link de inscriere' },
]

export function NewMenu() {
  const [deschis, setDeschis] = useState(false)
  const nav = useNavigate()
  const box = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!deschis) return
    const inchide = (e: MouseEvent) => {
      if (box.current && !box.current.contains(e.target as Node)) setDeschis(false)
    }
    const esc = (e: KeyboardEvent) => e.key === 'Escape' && setDeschis(false)
    document.addEventListener('mousedown', inchide)
    document.addEventListener('keydown', esc)
    return () => {
      document.removeEventListener('mousedown', inchide)
      document.removeEventListener('keydown', esc)
    }
  }, [deschis])

  return (
    <div className="relative" ref={box}>
      <button onClick={() => setDeschis((v) => !v)} aria-haspopup="menu" aria-expanded={deschis}
        className="inline-flex items-center gap-1.5 h-9 px-3.5 rounded-[var(--radius-control)] bg-accent text-white text-[14px] font-medium hover:bg-accent-ink transition-colors">
        <span className="text-[16px] leading-none">+</span> Nou
      </button>
      {deschis && (
        <div role="menu"
          className="absolute right-0 mt-1.5 w-64 z-20 bg-surface border border-line rounded-[var(--radius-card)] shadow-lg py-1.5">
          {ITEME.map((i) => (
            <button key={i.la} role="menuitem"
              onClick={() => { setDeschis(false); nav(i.la) }}
              className="w-full text-left px-4 py-2 hover:bg-page transition-colors">
              <span className="block text-[14px]">{i.titlu}</span>
              <span className="block text-[12px] text-muted">{i.sub}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
